<template>
	<div>
		<aside v-if="!ready" class="app-loading">
			<p>Loading Nearest Locations...</p>
		</aside>
		<aside v-if="ready">
			<div class="form mb-4">
				<div class="content">
					<fieldset>
						<label>Enter Zip Code</label>
						<input v-model="searchString"
							   type="number"
							   max="99999"
							   min="0"
							   tabindex="1"
							   required>
					</fieldset>
					<fieldset>
						<label>Search Within</label>
						<select v-model="searchRadius">
							<option value="5">5 Miles</option>
							<option value="20">20 Miles</option>
							<option value="50">50 Miles</option>
							<option value="100">100 Miles</option>
						</select>
						<button class="btn-beltone mt-2" @click="search()">
							<div v-show="loading" class="btn-spinner white">
								<div class="outer"><div class="inner"><span></span></div></div>
							</div>
							<span :class="{'hidden': loading}">Search</span>
						</button>
					</fieldset>
				</div>
			</div>
      <view-advanced v-if="showMap === 'true'"
                     ref="advanced"
                     :searchString="searchString"
                     :searchRadius="searchRadius"
                     :usingSearchString="usingSearchString"
                     :dealer-id="dealerId"/>
			<view-basic v-else />
		</aside>
	</div>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex';
	import EventBus from '../../js/eventBus'
	import Services from '../mixins/services';
	import ViewBasic from './../components/location-search/view-basic'
	import ViewAdvanced from './../components/location-search/view-advanced'
  import SchedulingModal from './../components/location-search/scheduling-modal'

	export default {
		mixins: [Services],
    props: {
      showMap: {
        type: String,
        default: 'false'
      },
      dealerId: {
        type: String,
        required: true,
      }
    },
		components: {
			ViewBasic,
			ViewAdvanced,
      SchedulingModal
		},
		data: function () {
			return {
				ready: false,
				loading: false,
				searchString: "",
				searchRadius: 20,
				isInitialStateOrCityPageLoad: false,
				isStateOrCityPage: false,
				usingSearchString: false,
				queryParams: null
			}
		},
    computed: mapState({
			geoLocation: state => state.LocationSearch.geoLocation,
			searchResults: state => state.LocationSearch.searchResults,
			clientToken: state => state.ClientToken.clientToken,
      clinicUrl: state => state.OnlineScheduling.clinicUrl,
		}),
    watch: {
      clinicUrl(newVal) {
        if (newVal) {
          this.openScheduling();
        } else {
          document.body.style.overflow = '';
        }
      }
    },
		methods: {
			...mapActions('GoogleApi', { getIpLocation: 'getIpLocation' }),
			...mapActions('ClientToken', { getClientToken: 'getClientToken' }),
			...mapActions('LocationSearch', { updateGeoLocation: 'updateGeoLocation' }),
			...mapActions('LocationSearch', { getSearchResults: 'getSearchResults' }),
			...mapActions('LocationSearch', { resetResults: 'resetResults' }),
      ...mapMutations('OnlineScheduling', { setStateValue: 'setStateValue' }),
      
      setSearchResults(longitude, latitude, searchRadius) {
        this.getSearchResults({
          Longitude: longitude,
          Latitude: latitude,
          SearchRadius: searchRadius || this.queryParams.get('radius'),
          ZipCode: this.queryParams.get('zip'),
          StateName: this.queryParams.get('state'),
          ExcludeMilesAway: this.isStateOrCityPage,
          PageNumber: 0,
          PageSize: searchRadius ? this.showMap === 'true' ? 8 : 3 : 96,
          replaceData: true,
          dealerId: this.dealerId,
          clientToken: this.clientToken,
					cb: () => {
            this.ready = true;
          }
        })
			},
			setGeolocation(longitude, latitude) {
				this.updateGeoLocation({
					longitude: longitude,
					latitude: latitude,
				});
        this.setSearchResults(longitude, latitude, 20000);
			},
			async search() {
				if (this.searchString.length === 0 && this.state.length === 0) return;
				this.loading = true;
				this.usingSearchString = true;
				let isNum = /^\d+$/.test(this.searchString);
				this.resetResults();
				this.getSearchResults({
					SearchRadius: this.searchRadius,
					ZipCode: isNum ? this.searchString : null,
					City: isNum ? null : this.searchString,
					PageSize: this.showMap === 'true' ? 8 : 3,
					PageNumber: 0,
          dealerId: this.dealerId,
					clientToken: this.clientToken,
					cb: () => {
						this.isInitialStateOrCityPageLoad = false;
						if (this.searchResults && this.showMap === 'true') {
							this.$refs.advanced.$refs.gMaps.searchLocations();
						}
						this.loading = false;
					}
				})
			},
      openScheduling() {
        SchedulingModal.open({ dealerId: this.dealerId });
      }
		},
    mounted() {      
			this.getClientToken({
				cb: () => {
					let useGeoLocation = true;
					this.queryParams = new URLSearchParams(window.location.search);
					this.isStateOrCityPage = (this.queryParams.get('zip') !== null && this.queryParams.get('radius') !== null) || this.queryParams.get('state') !== null;					
          if (this.isStateOrCityPage) {
						this.isInitialStateOrCityPageLoad = true;
						this.setSearchResults();
						useGeoLocation = false;
					}

          let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
          if (isSafari) {
            this.getIpLocation({
							cb: (res) => {
								if (useGeoLocation) {
									this.setGeolocation(res.lng, res.lat);
								}
              }
            })
          } else {
            this.getIpLocation({
							cb: (res) => {
								if (useGeoLocation) {
									this.setGeolocation(res.lng, res.lat);
								}
              }
            });
						navigator.geolocation.getCurrentPosition((position) => {
							if (useGeoLocation) {
								this.setGeolocation(position.coords.longitude, position.coords.latitude);
							}
            });
          }
				}
			});
		}
  }
</script>
